import React from 'react';
import { CTAButton } from '../CTAButton';
export function ImagineSection() {
  return <section className="w-full bg-plum-deep" data-id="element-224" data-mp="1g4d987ppvex9">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-225" data-mp="1g3k5lfm215jc">
        <h2 className="text-balance text-center font-display text-[29px] font-black leading-[1.12] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-226" data-mp="1ury97sraoy0y">
          Immagina di entrare in ogni consultazione sapendo esattamente cosa fare dopo.
        </h2>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-227" data-mp="1265em6g5kpp9">
          <div className="rounded-2xl bg-white/5 p-5 ring-1 ring-white/10" data-id="element-228" data-mp="x6j0zvwex7fx">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-white/45" data-id="element-229" data-mp="1b5igacy1c9zf">
              Invece di pensare:
            </p>
            <p className="mt-3 text-[16px] italic leading-snug text-white/65 sm:text-lg" data-id="element-230" data-mp="1723xjeippfia">
              “Lascia che ricontrolli prima le linee guida…”
            </p>
          </div>
          <div className="rounded-2xl bg-gold p-5" data-id="element-231" data-mp="2ihsmucjfuqm9">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-plum-deep/70" data-id="element-232" data-mp="3r5k6zf5y8qlz">
              Penserai:
            </p>
            <p className="mt-3 font-display text-[22px] font-black leading-tight text-plum-deep sm:text-2xl" data-id="element-233" data-mp="3w325ebmcbnfq">
              “Ho già la risposta.”
            </p>
          </div>
        </div>

        <p className="mt-8 text-center text-[15.5px] leading-relaxed text-white/75 sm:text-lg" data-id="element-234" data-mp="8ymd251lc2c7">
          Questo è ciò che offre il Progetto Clinico della Menopausa™: un sistema clinico
          ripetibile su cui puoi contare ogni giorno.
        </p>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-235" data-mp="3hfh50pguo2bi">
          <CTAButton label="Voglio avere questa sicurezza in ogni visita" variant="teal" data-id="element-236" data-mp="3hep89bbinyjn" />
          <p className="mt-3 text-center text-[13px] font-medium text-white/55 sm:text-sm" data-id="element-237" data-mp="3m78x54fnmg3r">
            Pagamento unico di 19 € • Garanzia soddisfatti o rimborsati di 7 giorni
          </p>
        </div>
      </div>
    </section>;
}